<template>
  <div @drop="handleDrop" v-loading="loading" id="drag" @dragleave.prevent @dragenter.prevent @dragover.prevent>
    <div class="no">{{ props.item.lab_ || props.item.lab }}</div>
    <img :src="MyImage.ass.doc" class="docImg" alt="" />
    <div class="dropTxt">
      <span>Drop your {{ props.item.lab }} here or </span>
      <div class="choBtnTxt">
        Choose file
        <input type="file" class="fileBtn" multiple required @change="changFile" />
      </div>
    </div>
    <div class="max">Max.File Size: 20 MB</div>
    <div v-if="props.item.url" class="file">
      {{ MyUtil.getFileName(props.item.url) }}
    </div>
  </div>
</template>
<script setup lang="ts">
import { ElMessage } from "element-plus";
import { ref } from "vue";

import { MyImage } from "@icon/MyImage";
import { MyUtil } from "@util";
import { postUploadFile } from "@/views/home/api";

interface Item {
  lab: string
  lab_?: string
  callback: (res: { file: File, url: string }) => void
  file?: File,
  url?: string
}
interface Props {
  item: Item
}
const props = defineProps<Props>()
const handleDrop = (e: any) => {
  e.preventDefault();
  const { files } = e.dataTransfer;
  return changFile(files[0]);
};

const changFile = (e: any) => {
  const file = e.target?.files[0];
  const tp = MyUtil.getFileType(file.name);
  if (tp != "doc" && tp != "docx") {
    ElMessage({
      showClose: true,
      message: "Unsupported file format",
      duration: 5000,
    });
    return;
  }
  upload(file);
  e.target.value = "";
};

const loading = ref(false);
const upload = async (file: File) => {
  const fd = new FormData();
  fd.append("file", file);
  loading.value = true;
  postUploadFile(fd)
    .then(({ data }) => {
      loading.value = false;
      const {
        resp: { code, msg },
        url,
      } = data;
      if (code == 0) {
        MyUtil.log("url==", url);
        props.item.callback({ file, url })
        // fileSel.value = file;
        // reportUrl.value = url;
      } else {
        ElMessage.error(msg);
      }
    })
    .catch((err) => {
      loading.value = false;
      ElMessage.error(err.message);
      MyUtil.log("err==", err);
    });
};
</script>

<style scoped>
#drag {
  flex: 1;
  border: 1px dashed #dedede;
  border-radius: var(--dimCirAll);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 80px var(--dimApp);
  margin-bottom: 34px;
  position: relative;
}

.no {
  position: absolute;
  left: 0;
  top: 0;
  background: #D0D0D0;
  border-radius: var(--dimCirCard) 0px var(--dimCirCard) 0px;
  font-weight: 500;
  padding: var(--dimLittle) var(--dimBig);
}

.docImg {
  height: 77px;
  object-fit: contain;
}

.dropTxt {
  font-size: var(--dimSmall);
  font-weight: 500;
  align-items: center;
  display: flex;
  margin-top: 20px;
}

.choBtnTxt {
  /* font-size: var(--dimLittle); */
  font-weight: 500;
  text-decoration: underline;
  color: var(--colorApp);
  margin-left: var(--dimSmall);
  overflow: hidden;
  display: inline-block;
  position: relative;
  cursor: pointer;
}

.fileBtn {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  outline: none;
  filter: alpha(opacity=0);
  border: none;
  -moz-opacity: 0;
  -khtml-opacity: 0;
  opacity: 0;
  cursor: pointer;
}

.max {
  font-size: var(--dimSmall);
  font-weight: 500;
  color: var(--colorHint);
  margin-top: var(--dimSmall);
}

.file {
  position: absolute;
  bottom: 20px;
  right: 40px;
  background: var(--colorApp);
  border-radius: 18px;
  /* font-size: 20px; */
  /* font-family: Work Sans; */
  font-weight: 500;
  color: white;
  padding: 10px 20px;
  font-size: var(--dimSmall);
}
</style>
